/**
 * Bounded Context: Initiative — composable
 */

import { storeToRefs } from "pinia";
import { useInitiativeStore } from "../store";

export function useInitiative() {
  const store = useInitiativeStore();
  const refs = storeToRefs(store);
  return {
    /** Refs reativas. */
    current: refs.current,
    currentOrNull: refs.currentOrNull,
    hasInitiative: refs.hasInitiative,
    userRequestedProvocation: refs.userRequestedProvocation,
    hasCuriosityGaps: refs.hasCuriosityGaps,
    userInUi: refs.userInUi,
    setUserInUi: (v: boolean): void => store.setUserInUi(v),
    setUserRequestedProvocation: (v: boolean): void =>
      store.setUserRequestedProvocation(v),
    setHasCuriosityGaps: (v: boolean): void => store.setHasCuriosityGaps(v),
    /** HLOS-40 — ações de override (R3/R4/R5). CC-05: zero penalidade. */
    refuseInitiative: (): void => store.refuseInitiative(),
    modifyInitiative: (userInput: string): void =>
      store.modifyInitiative(userInput),
  };
}
